var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 4.83342H9.83329V6.50008H8.16663V4.83342ZM8.16663 8.16675H9.83329V13.1667H8.16663V8.16675ZM8.99996 0.666748C4.39996 0.666748 0.666626 4.40008 0.666626 9.00008C0.666626 13.6001 4.39996 17.3334 8.99996 17.3334C13.6 17.3334 17.3333 13.6001 17.3333 9.00008C17.3333 4.40008 13.6 0.666748 8.99996 0.666748ZM8.99996 15.6667C5.32496 15.6667 2.33329 12.6751 2.33329 9.00008C2.33329 5.32508 5.32496 2.33341 8.99996 2.33341C12.675 2.33341 15.6666 5.32508 15.6666 9.00008C15.6666 12.6751 12.675 15.6667 8.99996 15.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.eba9958c65820c261961fe381f2cb6b9.svg";
export { ForwardRef as ReactComponent };